import { useState } from 'react'
import useToggle from '../../../../hooks/useToggle'
import Translation from '../../../Translation/cont/Translation'
import RadioButtonGroup from '../RadioButtonGroup'
import ButtonSubmitCancel from '../../../general/ButtonSubmitCancel'

const AddItemToList = ({
    options, 
    cap, 
    transIdLabel,
    transIdAdd = 'add_button',
    transIdCancel="cancel_button",
    transIdSubmit="add_button",
    classNameHeading='',
    classNameButtonGroup='',
    classNameSubmitCancel='',
    onAddItem
}) => {
    const [displayAdd, toggleDisplayAdd] = useToggle(false)
    const [choosenOption, setOption] = useState(false)

    const handleOptionChange = option => () => {
        setOption(option)
    }

    return (
        <div className={"add-item-to-list" + (displayAdd ? ' open' : ' close')}>
            <div className={(classNameHeading ? classNameHeading + ' ' : '') + "add-item-button cursor-pointer"} onClick={() => toggleDisplayAdd()}>
                <span><Translation id={transIdAdd} /></span>
            </div>

            {displayAdd && (
                <div className="add-item-popup">
                    <RadioButtonGroup
                        label={<Translation id={transIdLabel}/>}
                        className={'add-item-button-group' + (classNameButtonGroup ? ' ' + classNameButtonGroup : '')}
                    >
                        {options.map((option, index) => {
                            const id = option.itemType // Todo
                            const transId = option.transId
                            const value = option.itemType // Todo
                            const onChange = handleOptionChange(option)

                            return (
                                <label className="control control-radio" htmlFor={id} key={index}>
                                    <Translation id={transId} />
                                    <input
                                        id={id} 
                                        className="radio-button"
                                        type="radio" 
                                        value={value}
                                        onChange={onChange}
                                        checked={false !== choosenOption && choosenOption.itemType === value}
                                    />
                                    <div className="control_indicator"></div>
                                </label>
                            )
                        })}

                    </RadioButtonGroup>

                    <ButtonSubmitCancel
                        wrapperClassName={'add-item-submit-cancel' + (classNameSubmitCancel ? ' ' + classNameSubmitCancel : '')}
                        transIdCancel={transIdCancel}
                        transIdSubmit={transIdSubmit}
                        disabledSubmit={false === choosenOption}
                        cap={cap}
                        onSubmit={() => {
                            onAddItem(choosenOption)
                            toggleDisplayAdd()
                            setOption(false)
                        }}
                        onCancel={() => {
                            toggleDisplayAdd()
                            setOption(false)
                        }}
                    />
                </div>
            )}
        </div>
    )
}

export default AddItemToList